import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User } from '@/types'
import { authApi } from '@/api/auth'

export const useUserStore = defineStore('user', () => {
  // 状态
  const user = ref<User | null>(null)
  const token = ref<string | null>(localStorage.getItem('token'))

  // 计算属性
  const isLoggedIn = computed(() => !!token.value)

  // 方法
  const setToken = (newToken: string) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }

  const clearToken = () => {
    token.value = null
    localStorage.removeItem('token')
  }

  const setUser = (newUser: User | null) => {
    user.value = newUser
  }

  const login = async (username: string, password: string) => {
    const response = await authApi.login({ username, password })
    setToken(response.token)
    setUser(response.user)
    return response
  }

  const register = async (username: string, password: string, nickname?: string, inviteCode?: string) => {
    const response = await authApi.register({ username, password, nickname, invite_code: inviteCode })
    setToken(response.token)
    setUser(response.user)
    return response
  }

  const logout = () => {
    clearToken()
    setUser(null)
  }

  const fetchCurrentUser = async () => {
    if (!token.value) return null
    try {
      const userData = await authApi.getMe()
      setUser(userData)
      return userData
    } catch {
      clearToken()
      return null
    }
  }

  // 初始化时尝试获取用户信息
  if (token.value) {
    fetchCurrentUser()
  }

  return {
    user,
    token,
    isLoggedIn,
    login,
    register,
    logout,
    fetchCurrentUser,
    setToken,
    setUser,
  }
})
